import { css } from 'lit';
export default css `
    :host {
        --popover-background-color: var(--color-ui-08);
        --popover-safe-area: var(--spacing-m);

        --popover-trigger-height: auto;
        --popover-width: auto;
        --popover-height: auto;
        --popover-top: auto;
        --popover-left: auto;

        --popover-arrow-width: 0px;
        --popover-arrow-height: var(--spacing-xxs);
    }

    :host([enable-arrow]) {
        --popover-arrow-width: 24px;
        --popover-arrow-height: 10px;
    }

    /* Popover */

    .popover {
        position: fixed;
        width: var(--popover-width);
        left: clamp(
            var(--popover-safe-area),
            var(--popover-left),
            100vw - var(--popover-safe-area) - var(--popover-width)
        );
        z-index: 10;
    }

    :host(:not([is-visible])) .popover {
        pointer-events: none;
    }

    :host([position='start']) .popover {
        top: calc(var(--popover-top) - var(--popover-height) - var(--popover-arrow-height) - var(--spacing-xxs));
    }

    :host([position='end']) .popover {
        top: calc(
            var(--popover-top) + var(--popover-trigger-height) + var(--popover-arrow-height) + var(--spacing-xxs)
        );
    }

    /* Transition: toggle */

    :host([transition='toggle']) .transition-container {
        display: none;
    }

    :host([transition='toggle'][is-visible]) .transition-container {
        display: block;
    }

    /* Transition: fade */

    :host([transition='fade']) .transition-container {
        opacity: 0;
        transform: translateY(var(--spacing-xxs));
        transition: var(--transition-speed) var(--ease-in-out-quart);
        transition-property: opacity, transform;
    }

    :host([transition='fade'][is-visible]) .transition-container {
        opacity: 1;
        transform: translateY(0);
    }

    /* Arrow */

    .arrow-container,
    .arrow-overlay {
        position: fixed;
        left: clamp(
            var(--popover-safe-area),
            var(--popover-left) + var(--popover-width) / 2 - var(--popover-arrow-width) / 2,
            100vw - var(--popover-safe-area) + var(--popover-width) / 2 + var(--popover-arrow-width)
        );
        width: var(--popover-arrow-width);
        height: var(--popover-arrow-height);
        z-index: 10;
        pointer-events: none;
    }

    :host([position='start']) .arrow-container {
        top: calc(var(--popover-top) - var(--popover-arrow-height) - var(--spacing-xxs));
        filter: drop-shadow(0 -4px 4px var(--color-ui-04));
    }

    :host([position='end']) .arrow-container {
        top: calc(var(--popover-top) + var(--popover-trigger-height) + var(--spacing-xxs));
        filter: drop-shadow(0 4px 4px var(--color-ui-04));
    }

    .arrow {
        width: 100%;
        height: 100%;
        background: var(--popover-background-color);
    }

    :host([position='start']) .arrow {
        clip-path: polygon(0% 0%, 50% 100%, 100% 0%);
    }

    :host([position='end']) .arrow {
        clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
    }

    .arrow-overlay {
        background: var(--popover-background-color);
    }

    :host([position='start']) .arrow-overlay {
        top: calc(var(--popover-top) - var(--popover-arrow-height) - var(--spacing-xxs) - 1px);
        clip-path: polygon(0% 0%, 50% 100%, 100% 0%);
    }

    :host([position='end']) .arrow-overlay {
        top: calc(var(--popover-top) + var(--popover-trigger-height) + var(--spacing-xxs) + 1px);
        clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
    }

    /* Theme: blue */

    :host([theme='blue']) {
        --popover-background-color: var(--color-support-02);
        --color: var(--color-ui-08);
    }
`;
